<template>
	<div class="corp-block">
		<img width="40" height="40" src="./img/Business-Case.svg" />
		<p class="corp-block__text text-md">
			{{ $t('corpClientBlockText') }}
			<a class="corp-block__link" :href="corpLink" target="_blank"
				>{{ $t('findOutMore') }} &rarr;</a
			>
		</p>
	</div>
</template>

<script>
export default {
	name: 'CorpBlock',
	props: {
		tenantLinks: {
			type: Object,
		},
	},
	computed: {
		corpLink() {
			if (!this.tenantLinks) return;

			const url = new URL('corp-client', this.tenantLinks.NewApp);

			return url.toString();
		},
	},
};
</script>

<style lang="scss" scoped>
@import './CorpBlock.scss';
</style>
